import { observable, action } from 'mobx';
import moment from 'moment';
import ApiCaller from '../../utils/api-caller';

class wakeUpCallStore {

    // PROPERTIES

    @observable remark = '';

    @observable minDate = undefined;
    @observable minDateSecond = undefined;
    
    @observable dateDeliver = '';
    @observable dateDeliverDate = undefined;
    @observable timeDeliver = '';
    @observable timeDeliverDate = undefined;
    @observable timeDeliverSecond = '';
    @observable timeDeliverDateSecond = undefined;

    @observable menu = null;

    // Initialization

    @action initWakeUpCallConfirm() {
        this.remark = '';

        this.initDateTimeDeliver();

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getWakeUpCall(languageCode).then(resp => {
            return this.menu = resp;
        });
    }

    initDateTimeDeliver() {
        const now = moment();
        this.dateDeliver = now.format('D/M/yyyy');
        this.dateDeliverDate = now.toDate();
        this.timeDeliver = '';
        this.timeDeliverSecond = '';
        this.minDate = moment().toDate();
        this.minDateSecond = moment().toDate();
    }

    // Set Properties

    @action setRemark(value) {
        this.remark = value;
    }

    @action setDateDeliver(value) {
        var selectedDate = moment(value).format('D/M/yyyy');
        this.dateDeliver = selectedDate;

        this.timeDeliver = '';
        this.timeDeliverDate = '';

        this.timeDeliverSecond = '';
        this.timeDeliverDateSecond = '';
    }
    
    @action setDateDeliverDate(value) {
        this.dateDeliverDate = value;
        var selectedDate = moment(value).format('D/M/yyyy');
        var currentDate = moment().format('D/M/yyyy');

        if (selectedDate === currentDate) {
            this.minDate = moment().toDate();
            this.minDateSecond = moment().toDate();
        } else {
            let minDate = moment().toDate();
            minDate.setHours(0);
            minDate.setMinutes(0);

            this.minDate = minDate;
            this.minDateSecond = minDate;
        }

        this.timeDeliverDate = this.minDate;
        this.timeDeliverDateSecond = this.minDate;
    }

    @action setTimeDeliver(value) {
        this.timeDeliver = value;
        this.timeDeliverSecond = '';
        this.timeDeliverDateSecond = '';
    }

    @action setTimeDeliverDate(value) {
        this.timeDeliverDate = value;

        let minSecondDate = moment(this.timeDeliverDate).toDate();
        minSecondDate.setMinutes(minSecondDate.getMinutes() + 1);

        this.minDateSecond = minSecondDate;
    }

    @action setTimeDeliverSecond(value) {
        this.timeDeliverSecond = value;
    }

    @action setTimeDeliverDateSecond(value) {
        this.timeDeliverDateSecond = value;
    }

    @action resetData() {
        this.menu = null;
    }
}

export default new wakeUpCallStore()